var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomelessness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Camping-Tent-Sleep--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Camping Tent Sleep Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.54 22.79a2 2 0 0 0 0.46 -1.66L21.83 9.75a2 2 0 0 0 -0.9 -1.33L13 3.45V1.5a1 1 0 0 0 -2 0v2l-7.93 5a2 2 0 0 0 -0.9 1.33L0 21.13a2 2 0 0 0 0.43 1.66A2 2 0 0 0 2 23.5h20a2 2 0 0 0 1.54 -0.71ZM2.6 21.5a0.51 0.51 0 0 1 -0.49 -0.6l2 -10.57a0.49 0.49 0 0 1 0.21 -0.33l7.41 -4.65a0.52 0.52 0 0 1 0.54 0L19.69 10a0.48 0.48 0 0 1 0.22 0.33l2 10.58a0.51 0.51 0 0 1 -0.1 0.41 0.53 0.53 0 0 1 -0.39 0.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16h-6.5a0.5 0.5 0 0 0 -0.5 0.5v3a0.5 0.5 0 0 0 0.5 0.5h8a0.5 0.5 0 0 0 0.5 -0.5V18a2 2 0 0 0 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomelessness);
export default ForwardRef;